import { type CollectionModelFieldSelectList, FormModelFieldSelectList } from '@ikegps/core-shared';
import { action, computed, override, makeObservable } from 'mobx';
import { T, Translate } from '../../i18n';
import { type MultiChooserGroup, type MultiChooserGroupItem, MultiChooserState } from './multi.list.chooser.state';

export class SelectListChooserState extends MultiChooserState {
	field: CollectionModelFieldSelectList;
	formField: FormModelFieldSelectList;

	constructor(field: CollectionModelFieldSelectList) {
		super(field.schema.displayName);

		makeObservable(this);

		this.field = field;
		this.formField = field.schema;

		this.setValue([this.field.value]);
	}

	@computed override get displayValue(): string {
		return this.field.hasValue() ? this.field.displayValue : null;
	}

	@computed override get groups(): MultiChooserGroup[] {
		const visibleOptions = this.getVisibleOptions();

		if (visibleOptions.length === 0) {
			return [];
		}

		return [
			{
				title: Translate(T.SELECT_OPTION),
				items: visibleOptions,
				selected: this.value != null ? this.value[0] : visibleOptions[0].key,
			},
		];
	}

	@override override setValue(value: string[]): void {
		if (value == null || value.length === 0 || value[0] === FormModelFieldSelectList.UNSELECTED_VALUE) {
			this._value = null;
		} else {
			this._value = value;
		}
	}

	@action selectDefaultValue() {
		const visibleOptions = this.getVisibleOptions();
		if (visibleOptions.length > 0) {
			this.setValue([visibleOptions[0].key]);
			return;
		}

		this.setValue(null);
	}

	private getVisibleOptions(): MultiChooserGroupItem[] {
		const visibleOptions: MultiChooserGroupItem[] = [];
		for (const option of this.formField.options) {
			if (option.value !== FormModelFieldSelectList.UNSELECTED_VALUE) {
				visibleOptions.push({ key: option.value, value: option.text, color: option.color });
			}
		}
		return visibleOptions;
	}
}
